import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';
import * as debug from 'debug';
import { CrudApiProvider } from '../crud-api/crud-api';
import { EventEmitter } from '../../includes/eventEmitter';

@Injectable()
export class ConfigProvider extends EventEmitter {
  log = debug('app:ConfigProvider');

  loaded = false;
  configs = {
    hashtags: [],
    commentDisplayThreshold: 3,
    activeStatus: {
      value: 3,
      type: 'hour',
    },
  };
  fallbacks = {
    contentCategories: [
      {
        key: 'VIOLENCE',
        type: 'controversial',
        title: 'Extreme Violence',
      },
      {
        key: 'SEX',
        type: 'controversial',
        title: 'Sexual Content',
      },
      {
        key: 'POLITICS',
        type: 'controversial',
        title: 'Politics',
      },
      {
        key: 'OTHER_CONTROVERSIAL',
        type: 'controversial',
        title: 'Other Controversial Content',
      },
      {
        key: 'OTHER',
        title: 'Other',
      },
    ],
    feedContentTypes: [
      {
        key: 'VIOLENCE',
        title: 'Extreme Violence',
        options: ['SHOW', 'ASK_SENSITIVE', 'NO_SENSITIVE', 'HIDE'],
      },
      {
        key: 'SEX',
        title: 'Sexual Content',
        options: ['SHOW', 'ASK_SENSITIVE', 'NO_SENSITIVE', 'HIDE'],
      },
      {
        key: 'POLITICS',
        title: 'Politics',
        options: ['SHOW', 'ASK_SENSITIVE', 'NO_SENSITIVE', 'HIDE'],
      },
      {
        key: 'OTHER_CONTROVERSIAL',
        title: 'Other Controversial Content',
        options: ['SHOW', 'ASK_SENSITIVE', 'NO_SENSITIVE', 'HIDE'],
      },
      {
        key: 'OTHER',
        title: 'Trucking Content',
        options: ['SHOW', 'ASK_SENSITIVE', 'NO_SENSITIVE'],
      },
    ],
  };

  constructor(public crudApi: CrudApiProvider) {
    super();
    this.log('constructed');

    this.crudApi.get('/api/configs').then(
      c => {
        _.merge(this.configs, c.data);
        this.crudApi
          .get('/api/hashtags')
          .then(hashtags => {
            _.set(this.configs, 'hashtags', hashtags.data);

            this.emit('loaded', _.cloneDeep(this.configs));
            this.log('loaded', this.configs);
            this.loaded = true;
          })
          .catch(e => {
            console.log('get hashtags failed', e);
            this.emit('loaded', _.cloneDeep(this.configs));
            this.log('loaded', this.configs);
            this.loaded = true;
          });
      },
      e => {
        // not really, but prevents waiting and uses defaults
        this.emit('loaded', _.cloneDeep(this.configs));
      }
    );
  }

  loadConfigs() {
    if (this.loaded) {
      this.log('already loaded');
      return Promise.resolve(_.cloneDeep(this.configs));
    } else {
      return new Promise((resolve, reject) => {
        this.once('loaded', () => {
          resolve(_.cloneDeep(this.configs));
        });
      });
    }
  }

  resetTags() {
    const hashtags = _.each(this.configs.hashtags, t => {
      _.set(t, 'selected', false);
    });
    _.set(this.configs, 'hashtags', hashtags);
    this.emit('hashtagsUpdated', this.configs.hashtags);
  }

  updateSelectedTags(tag) {
    let hashtags = _.each(this.configs.hashtags, t => {
      if (t.name === tag.name) _.set(t, 'selected', tag.selected);
    });

    this.log(
      'hashtags | hashtagsUpdated',
      _.cloneDeep(this.configs.hashtags),
      _.compact(_.map(this.configs.hashtags, t => t.selected && t.name))
    );
    _.set(this.configs, 'hashtags', hashtags);
    this.emit('hashtagsUpdated', this.configs.hashtags);
  }

  get(key?) {
    if (!key) {
      return _.cloneDeep(this.configs);
    }
    return _.cloneDeep(_.get(this.configs, key) || _.get(this.fallbacks, key));
  }
}



// WEBPACK FOOTER //
// ./src/providers/config/config.ts